export function AdminPrototype (pConfig)
{
  return (
  {
    name : 'EditorToolbarPrototypeConfig',

    Groups :
    [
      {
        name : 'HistoryActions',
        visible : true
      },

      {
        name : 'HistoryActionsMini',
        visible : true
      },

      {
        name : 'BlockActions',
        visible : true
      },

      {
        name : 'TextAlign',
        visible : true
      },

      {
        name : 'TextAlignMini',
        visible : true
      },

      {
        name : 'FontColors',
        visible : true
      },

      {
        name : 'FontColorsMini',
        visible : true
      },

      {
        name : 'FontColorsEmail',
        visible : true
      },

      {
        name : 'TextActions',
        visible : true
      },

      {
        name : 'TextActionsMini',
        visible : true
      },

      {
        name : 'CopyPaste',
        visible : true
      },

      {
        name : 'CopyPasteMini',
        visible : true
      },

      {
        name : 'HTML',
        visible : true
      },

      {
        name : 'HTMLMini',
        visible : true
      },

      {
        name : 'BlockStyles',
        lineBreak : true,
        visible : true
      },

      {
        name : 'BlockStylesMini',
        lineBreak : true,
        visible : true
      },

      {
        name : 'BlockStylesEmail',
        lineBreak : true,
        visible : true
      },

      {
        name : 'TextDecoration',
        visible : true
      },

      {
        name : 'TextDecorationDropdown',
        visible : true,
        isDropdown: true
      },

      {
        name : 'BigSizeButtons',
        visible : true
      },

      {
        name : 'BigSizeButtonsMini',
        visible : true
      },

      {
        name : 'BigSizeButtonsEvent',
        visible : true
      },

      {
        name : 'BigSizeButtonsEmail',
        visible : true
      }
    ]
  });
}